/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WarehousesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a warehouse
     * @returns any Warehouse created
     * @throws ApiError
     */
    public createWarehouse({
        requestBody,
    }: {
        requestBody?: {
            name: string;
            use_bins?: boolean;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        use_bins: boolean;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/warehouses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                403: `Owner role required`,
                409: `Warehouse already exists`,
            },
        });
    }
    /**
     * List warehouses
     * @returns any Warehouse list
     * @throws ApiError
     */
    public getWarehouses(): CancelablePromise<Array<{
        id: string;
        name: string;
        use_bins: boolean;
        created_at: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/warehouses',
        });
    }
    /**
     * Update a warehouse
     * @returns any Warehouse updated
     * @throws ApiError
     */
    public updateWarehouse({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            name: string;
            use_bins?: boolean;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        use_bins: boolean;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/warehouses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                403: `Owner role required`,
                404: `Warehouse not found`,
                409: `Warehouse already exists`,
            },
        });
    }
}
